export function video() {
    let videoHolder = $(".media-single-slider");
    videoHolder.on("click", ".play-button", function (e) {
        e.preventDefault();

        const playBtn = $(this);
        const parent = $(this).closest(".article-media-block, .image-holder");

        parent.addClass("video-play");

        if (playBtn.attr("href").includes("mp4")) {
            setTimeout(() => {
                parent.append(`<video src="` + playBtn.attr("href") + `" loop controls></video>`);
                parent.find('video')[0].play();
            }, 700);
        } else {
            parent.append(`<iframe src="` + playBtn.attr("href") + `?enablejsapi=1&autoplay=0" frameborder="0" allow="autoplay" allowfullscreen playsinline allowfullscreen></iframe>`);

            setTimeout(() => {
                parent.find('iframe')[0].contentWindow.postMessage('{"event":"command", "method":"play", "func":"' + 'playVideo' + '","args":""}', '*');
            }, 700);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/video.js